import React, { useState, useEffect } from "react";
import { Link, useHistory } from "react-router-dom";
import { firebase, database } from "../../database/firebase";
import logo from "./traceai_logo.png";

function Header() {
  const history = useHistory();
  const [role, setRole] = useState(localStorage.getItem("role"));
  const [upgradeRole, setUpgradeRole] = useState();
  const [contactUs, setContactUs] = useState();
  const [showUpgrade, setShowUpgrade] = useState(false);
  const [showThank, setShowThank] = useState(false);
  const [showContactUs, setShowContactUs] = useState(false);
  const [selectFocus1, setSelectFocus1] = useState(false);
  const [selectFocus2, setSelectFocus2] = useState(false);
  const [selectFocus3, setSelectFocus3] = useState(false);
  const [selectFocus4, setSelectFocus4] = useState(false);

  useEffect(() => {
    const btn = document.querySelector(".mobile-menu-button");
    const sidebar = document.querySelector(".sidebar");

    btn.addEventListener("click", () => {
      sidebar.classList.toggle("-translate-x-full");
    });
  }, []);

  const handleSubmit = async () => {
    firebase
      .auth()
      .signOut()
      .then(() => {
        localStorage.removeItem("uid");
        alert("Logout successful.");
        history.push("login");
      });

  };
  const submitUpgradeMembership = async () => {

    let uid = JSON.parse(localStorage.getItem("uid"))

    if (upgradeRole !== undefined) {
      database.child(`users/${uid}/requestRole`).update(
        {
          'role': upgradeRole,
          'requestRoleStatus': "pending"
        }
      ).then(() => {
        //alert('Role updated.');
        console.log(upgradeRole)
        setShowThank(true)

        setSelectFocus1(false)
        setSelectFocus2(false)
        setSelectFocus3(false)
        setSelectFocus4(false)
      })
        .catch((error) => {
          console.log('error rtd', error);
        });
    } else {
      alert("Select membership type.")
    }
  }

  const selectUpgradeMembership = (val) => {
    setSelectFocus1(false)
    setSelectFocus2(false)
    setSelectFocus3(false)
    setSelectFocus4(false)

    setUpgradeRole(val)
    console.log(val)
    switch (val) {
      case "view":
        setSelectFocus1(true)
        break;
      case "admin":
        setSelectFocus2(true)
        break;
      case "superview":
        setSelectFocus3(true)
        break;
      case "superadmin":
        setSelectFocus4(true)
        break;
      default:
    }
  }
  const showUpgradeMembership = () => {
    setShowUpgrade(true);
  }

  const submitContactAdmin = async () => {
    console.log(contactUs)

    let uid = JSON.parse(localStorage.getItem("uid"))

    if (contactUs !== undefined) {
      database.child(`users/${uid}/contactUs`).push(
        {
          'message': contactUs,
          'messageStatus': "pending"
        }
      ).then(() => {
        alert('Message succesfully sent.');
        setContactUs()
        setShowContactUs(false)
      })
        .catch((error) => {
          console.log('error rtd', error);
        });
    } else {
      alert("Enter message.")
    }

  }

  const handleContactChange = (e) => {
    setContactUs()
    const { value } = e.target;
    setContactUs(value);
  }

  const showContactAdmin = () => {
    setShowContactUs(true)
  }

  const closeUpgrade = () => {
    setShowThank(false)
    setShowUpgrade(false)
  }

  const closeContactUs = () => {
    setContactUs()
    setShowContactUs(false)
  }

  function capitalize(s) {

    switch (s) {
      case "view":
        s = "User (L1 View)"
        break;
      case "superview":
        s = "User (L2 View)"
        break;
      case "admin":
        //s = "Admin (L1 Editor)"
        s = "Basic"
        break;
      case "superadmin":
        //s = "Admin (L2 Editor)"
        s = "Premium"
        break;
      case "master":
        s = "Master User"
        break;
      case "developer":
        s = "Developer"
        break;

      default:
        s = "role"
    }
    return s && s[0].toUpperCase() + s.slice(1);
  }

  return (
    <div className="md:relative md:min-h-screen md:flex">
      {showThank ? (
        <>
          <div
            className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
            <div className="relative w-auto my-6 mx-auto max-w-max">
              <div className="pt-4 pb-6 px-6 bg-blue-800 rounded-lg shadow-2xl relative flex flex-col w-full outline-none focus:outline-none">
                <div className="flex items-start justify-between rounded-t">


                  <button
                    className="p-1 ml-auto  border-0 text-white float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
                    onClick={closeUpgrade}
                  >
                    <span className="text-black-900  h-6 w-6 text-2xl block outline-none focus:outline-none">
                      ×
                    </span>
                  </button>

                </div>
                <div >
                  <div className="text-white text-center text-3xl px-2">
                    Your membership plan
                  </div>
                  <div className=" text-white  text-center text-3xl px-2 pb-4">
                    change request is submitted!
                  </div>
                  <div className="text-white  flex flex-col items-center">
                    <div className="flex text-center text-s text-white">
                      Please check your email within 1-2 business days
                    </div>
                    <div className="flex text-center text-s text-white">
                      for instructions to activate your new membership plan.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      ) : null}
      {showUpgrade ? (
        <>
          <div
            className="justify-center 0 items-center flex overflow-y-auto fixed inset-0 z-40 outline-none focus:outline-none">
            <div className="relative w-auto my-6 mx-auto max-w-max">
          
              <div className="py-4 px-2 border border-blue-600  rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                <div className="flex items-start justify-between px-5 rounded-t">


                  <button
                    className="p-1 ml-auto  border-0 text-black-900 float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
                    onClick={() => setShowUpgrade(false)}
                  >
                    <span className="text-black-900  h-6 w-6 text-2xl block outline-none focus:outline-none">
                      ×
                    </span>
                  </button>

                </div>
              
                <div className="text-center sm:text-3xl text-gray-600 ">
                  Choose Account Type
                </div>
               
                {/*body*/}
                <div className="sm:flex justify-between h-96 overflow-y-auto">
                  <div className="flex flex-col text-center p-6">

                    <div className="p-4 rounded-lg border border-gray-400 bg-white transform transition ease-in-out duration-700 hover:scale-105">

                      <div className="flex flex-col items-center mb-16">
                        <div className="flex text-sm">
                          Free Tier
                        </div>
                        <div className="flex text-3xl font-bold">
                          Basic
                        </div>
                        <div className="flex text-xs">
                          Recommended for Enumerators
                        </div>

                      </div>
                      <div className="flex flex-col">
                        <div className="flex text-xs font-light"> Features:</div>

                        <div className="flex text-sm items-center">
                          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="w-4 h-4 mr-1">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 12.75l6 6 9-13.5" />
                          </svg>

                          View seafood catch records </div>

                        <div className="flex text-sm items-center">
                          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="w-4 h-4 mr-1">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 12.75l6 6 9-13.5" />
                          </svg>

                          View sub-accounts</div>

                        <div className="flex text-sm items-center">
                          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="w-4 h-4 mr-1">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 12.75l6 6 9-13.5" />
                          </svg>

                          View Fishermen Records </div>
                        <div className="flex text-sm items-center">
                          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="w-4 h-4 mr-1">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 12.75l6 6 9-13.5" />
                          </svg>

                          Register Fishermen </div>

                        <div>
                        {selectFocus1 ?
                          <>
                            <button className="text-white bg-red-600 rounded-full px-6 py-1 m-1 hover:bg-red-700"
                              onClick={() => setSelectFocus1(false)}>
                              Unselect
                            </button>
                          </>
                          :
                          <>
                            <button className="text-white bg-blue-600 rounded-full px-6 py-1 m-1 hover:bg-blue-700"
                              onClick={() => selectUpgradeMembership("view")}>
                              Select
                            </button>
                          </>
                        }
                        </div>
                       

                      </div>
                    </div>



                  </div>

                  <div className="flex flex-col text-center p-6">
                  
                    <div className="p-4 rounded-lg border border-blue-600 bg-white transform transition ease-in-out duration-700 hover:scale-105">

                      <div className="flex flex-col items-center mb-20">
                        <div className="flex text-sm">
                          Paid Tier
                        </div>
                        <div className="flex text-3xl font-bold">
                          Premium
                        </div>
                        <div className="flex text-xs">
                          Recommended for Fisheries Manager
                        </div>

                      </div>
                      <div className="flex flex-col mb-6">
                        <div className="flex text-xs font-light"> Features:</div>
                        <div className="flex text-sm items-center">
                          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="w-4 h-4 mr-1">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 12.75l6 6 9-13.5" />
                          </svg>

                          All Basic Tier Features </div>
                        <div className="flex text-sm items-center">
                          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="w-4 h-4 mr-1">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 12.75l6 6 9-13.5" />
                          </svg>

                          Export CSV/Excel File</div>
                      </div>

                      <div>
                        {selectFocus2 ?
                          <>
                            <button className="text-white bg-red-600 rounded-full px-6 py-1 m-1 hover:bg-red-700"
                              onClick={() => setSelectFocus2(false)}>
                              Unselect
                            </button>
                          </>
                          :
                          <>
                            <button className="text-white bg-blue-600 rounded-full px-6 py-1 m-1 hover:bg-blue-700"
                              onClick={() => selectUpgradeMembership("admin")}>
                              Select
                            </button>
                          </>
                        }
                      </div>
                    </div>
                  </div>

                </div>

                <button className="mx-auto text-white bg-blue-600 rounded-full px-6 py-1 m-2 hover:bg-blue-700"
                  onClick={submitUpgradeMembership}>
                  Submit
                </button>

              </div>
          
              
            </div>
          </div >
        </>
      ) : null
      }
      {
        showContactUs ? (
          <>
            <div
              className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-20 outline-none focus:outline-none">
              <div className="relative w-auto my-6 mx-auto max-w-max">
                <div className="pt-1 pb-6 px-5 bg-white rounded-lg shadow-2xl relative flex flex-col w-full outline-none focus:outline-none">
                  <div className="flex rounded-t">


                    <button
                      className="pt-2 ml-auto  border-0 text-gray-800 float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
                      onClick={closeContactUs}
                    >
                      <span className="text-black-900  h-6 w-6 text-2xl block outline-none focus:outline-none">
                        ×
                      </span>
                    </button>

                  </div>
                  <div className="w-96 px-5">
                    <div className="text-blue-600 text-xl py-4">
                      Send us a message!
                    </div>
                    <textarea
                      name="contactUs"
                      id="contactUs"
                      placeholder="Enter message here."
                      className="w-full h-16 px-3 py-2 text-base text-gray-700 placeholder-gray-600 border rounded-lg focus:shadow-outline"
                      onChange={handleContactChange}
                    />
                    <button className="text-white bg-blue-600 rounded-full px-6 py-1 my-2 hover:bg-blue-700"
                      onClick={submitContactAdmin}>
                      Submit
                    </button>

                  </div>
                </div>
              </div>
            </div>
          </>
        ) : null
      }

      <div className="bg-blue-800 flex justify-between md:hidden">
        <img src={logo} alt="logo" width="200px" className="m-2 text-white flex items-center space-x-2 px-4" />
        <button
          class="mobile-menu-button p-4 focus:outline-none focus:bg-yellow-400">
          <svg class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="white">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
          </svg>
        </button>
      </div>

      <div class="sidebar bg-blue-800 text-blue-100 w-72 py-7 px-2 absolute inset-y-0 left-0 transform -translate-x-full md:relative md:translate-x-0 transition duration-200 ease-in-out">
        <img src={logo} alt="" className="mb-6 text-white flex items-center space-x-2 px-4" />
        <nav>
          <ul>

            {role === "developer" || role === "master" || role === "admin" || role === "superadmin" ? (
              <li className="flex flex-row py-1 font-regular items-center text-lg px-4 rounded transition duration-200 hover:bg-blue-700 hover:text-white">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 m-2" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z" />
                </svg>
                <Link to="/newcatch">New Seafood Catch</Link>
              </li>) : (<div></div>)}

            {role === "developer" || role === "master" || role === "admin" || role === "superadmin" ? (
              <li className="flex flex-row items-center  py-1 font-regular text-lg px-4 rounded transition duration-200 hover:bg-blue-700 hover:text-white">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 m-2" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M4 7v10c0 2.21 3.582 4 8 4s8-1.79 8-4V7M4 7c0 2.21 3.582 4 8 4s8-1.79 8-4M4 7c0-2.21 3.582-4 8-4s8 1.79 8 4m0 5c0 2.21-3.582 4-8 4s-8-1.79-8-4" />
                </svg>
                <Link to="/history">Seafood Catch</Link>
              </li>) : (<div></div>)}
            {role === "developer" || role === "master" || role === "admin" || role === "superadmin" ? (
              <li className="flex flex-row items-center  py-1 font-regular text-lg px-4 rounded transition duration-200 hover:bg-blue-700 hover:text-white">

                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 m-2" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M2.25 7.125C2.25 6.504 2.754 6 3.375 6h6c.621 0 1.125.504 1.125 1.125v3.75c0 .621-.504 1.125-1.125 1.125h-6a1.125 1.125 0 01-1.125-1.125v-3.75zM14.25 8.625c0-.621.504-1.125 1.125-1.125h5.25c.621 0 1.125.504 1.125 1.125v8.25c0 .621-.504 1.125-1.125 1.125h-5.25a1.125 1.125 0 01-1.125-1.125v-8.25zM3.75 16.125c0-.621.504-1.125 1.125-1.125h5.25c.621 0 1.125.504 1.125 1.125v2.25c0 .621-.504 1.125-1.125 1.125h-5.25a1.125 1.125 0 01-1.125-1.125v-2.25z" />
                </svg>

                <Link to="/usercatchhistory"> Sub-accounts</Link>
              </li>) : (<div></div>)}

            {role === "developer" || role === "master" || role === "admin" || role === "superadmin" ? (
              <li className="flex flex-row items-center  py-1 font-regular text-lg px-4 rounded transition duration-200 hover:bg-blue-700 hover:text-white">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 m-2" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
                </svg>
                <Link to="/record">Fisherman</Link>
              </li>) : (<div></div>)}

            {/* {role === "developer" || role === "master" || role === "superadmin" || role === "superview" ? (
              <li className="flex flex-row items-center py-1 font-regular text-lg px-4 rounded transition duration-200 hover:bg-blue-700 hover:text-white">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 m-2" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
                </svg>
                <Link to="/adminrecord">Accounts</Link>
              </li>) : (<div></div>)} */}

            {role === "developer" ? (
              <li className="flex flex-row items-center py-1 font-regular text-lg px-4 rounded transition duration-200 hover:bg-blue-700 hover:text-white">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 m-2" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
                </svg>
                <Link to="/useraccounts">Accounts</Link>
              </li>) : (<div></div>)}

            {role === "developer" || role === "master" || role === "admin" || role === "superadmin" ? (
              <li className="flex flex-row items-center py-1 px-4 font-regular text-lg rounded transition duration-200 hover:bg-blue-700 hover:text-white">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 m-2" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                </svg>
                <Link to="/registerfisher">Register Fisherman</Link>
              </li>) : (<div></div>)}

            {role === "developer" || role === "master" ? (
              <li className="flex flex-row items-center py-1 px-4 font-regular text-lg rounded transition duration-200 hover:bg-blue-700 hover:text-white">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 m-2" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                </svg>
                <Link to="/registeruser">Register Users</Link>
              </li>) : (<div></div>)}

            <button
              onClick={handleSubmit}
              type="submit"
              className="my-4 w-full bg-blue-600 text-white text-base font-regular py-2 px-4 rounded-lg shadow-md hover:bg-yellow-400 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:ring-offset-2 focus:ring-offset-purple-200">
              Logout</button>
          </ul>
        </nav>

        <div className="flex flex-col w-full p-2 border-gray-800 absolute bottom-0">
          <div className="flex flex-row items-center my-1">
            <div className="flex mr-2 font-light">
              Account Type </div>
            <div className="flex py-1 px-4 rounded-sm border-2 border-yellow-600 text-center text-yellow-600justify-center">
              {capitalize(role)}
            </div>
          </div>


          <button className="my-1 mr-2 flex flex-row text-center justify-center border border-blue-600 text-white text-base font-regular py-2 px-4 rounded-lg shadow-md hover:bg-yellow-500 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:ring-offset-2 focus:ring-offset-purple-200"
            type="submit"
            onClick={showUpgradeMembership}>
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="w-6 h-6 mx-2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M15.59 14.37a6 6 0 01-5.84 7.38v-4.8m5.84-2.58a14.98 14.98 0 006.16-12.12A14.98 14.98 0 009.631 8.41m5.96 5.96a14.926 14.926 0 01-5.841 2.58m-.119-8.54a6 6 0 00-7.381 5.84h4.8m2.581-5.84a14.927 14.927 0 00-2.58 5.84m2.699 2.7c-.103.021-.207.041-.311.06a15.09 15.09 0 01-2.448-2.448 14.9 14.9 0 01.06-.312m-2.24 2.39a4.493 4.493 0 00-1.757 4.306 4.493 4.493 0 004.306-1.758M16.5 9a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z" />
            </svg>

            Upgrade</button>

          <button className="my-1 mr-2 text-center flex flex-row justify-center border-blue-600 text-white text-base font-regular py-2 px-4 rounded-lg shadow-md hover:bg-blue-600 hover:border-none focus:outline-none focus:ring-2 focus:ring-purple-500 focus:ring-offset-2 focus:ring-offset-purple-200"
            type="submit"
            onClick={showContactAdmin}>
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="w-6 h-6 mx-2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M8.625 9.75a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0H8.25m4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0H12m4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0h-.375m-13.5 3.01c0 1.6 1.123 2.994 2.707 3.227 1.087.16 2.185.283 3.293.369V21l4.184-4.183a1.14 1.14 0 01.778-.332 48.294 48.294 0 005.83-.498c1.585-.233 2.708-1.626 2.708-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0012 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018z" />
            </svg>

            Contact Us</button>

        </div>

      </div>
    </div >
  );

}

export default Header;